import * as yup from "yup";

import { BaseYup, emailRegExp, kanjiKanaFullHiraganaRegExp, katakanaRegExp, MAX_INPUT, postCodeRegExp } from "@/config/baseYup";
import i18n from '@/config/i18n';

export const registerAccountFormSchema = BaseYup.object({
  first_name: BaseYup.string()
    .label(i18n.t('user.first_name'))
    .required()
    .matches(katakanaRegExp, {
      message: i18n.t('common.form.katakana_invalid', {
        label_name: i18n.t('user.first_name'),
      }),
    })
    .max(MAX_INPUT),
  last_name: BaseYup.string()
    .label(i18n.t('user.last_name'))
    .required()
    .matches(katakanaRegExp, {
      message: i18n.t('common.form.katakana_invalid', {
        label_name: i18n.t('user.last_name'),
      }),
    })
    .max(MAX_INPUT),
  first_name_kanji: BaseYup.string()
    .label(i18n.t('user.first_name_kanji'))
    .required()
    .matches(kanjiKanaFullHiraganaRegExp, {
      message: i18n.t('common.form.kanji_kana_hira_invalid', {
        label_name: i18n.t('user.first_name_kanji'),
      }),
    })
    .max(MAX_INPUT),
  last_name_kanji: BaseYup.string()
    .label(i18n.t('user.last_name_kanji'))
    .required()
    .matches(kanjiKanaFullHiraganaRegExp, {
      message: i18n.t('common.form.kanji_kana_hira_invalid', {
        label_name: i18n.t('user.last_name_kanji'),
      }),
    })
    .max(MAX_INPUT),
  date_of_birth: BaseYup.string()
    .label(i18n.t('register_account.personal_section.date_of_birth'))
    .required()
    .max(MAX_INPUT),
  gender: BaseYup.string()
    .label(i18n.t('register_account.personal_section.gender'))
    .required()
    .max(MAX_INPUT)
    .transform(function (_value, originalValue) {
      if (typeof originalValue === 'object' && originalValue !== null) {
        return originalValue.value;
      }
      return originalValue;
    }),
  email: BaseYup.string()
    .label(i18n.t('register_account.contact_section.email_address'))
    .required()
    .matches(emailRegExp, {
      message: i18n.t('common.form.email_invalid'),
      excludeEmptyString: true,
    })
    .max(MAX_INPUT),
  phone_number: BaseYup.string()
    .label(i18n.t('register_account.contact_section.phone_number'))
    .required()
    .min(10, i18n.t('register_account.error.phone_number_length'))
    .max(15, i18n.t('register_account.error.phone_number_length')),
  post_code: BaseYup.string()
    .required()
    .label(i18n.t('register_account.address_section.post_code'))
    .min(5, i18n.t('common.form.post_code_length'))
    .max(32, i18n.t('common.form.post_code_length'))
    .matches(postCodeRegExp, {
      message: i18n.t('common.form.post_code_invalid', {
        label_name: i18n.t('register_account.address_section.post_code'),
      }),
    }),
  address: BaseYup.string()
    .label(i18n.t('register_account.address_section.address'))
    .required()
    .max(MAX_INPUT),
  graduation_term_id: BaseYup.number()
    .required(i18n.t('register_account.service_section.graduation'))
    .transform((value) => (Number.isNaN(value) ? null : value)),
  plan_id: BaseYup.number()
    .required()
    .transform((value) => (Number.isNaN(value) ? null : value)),
})

export type RegisterAccountFormSchemaType = yup.InferType<typeof registerAccountFormSchema>